export enum ErrorCodes {
  E0001 = "E0001",
  E0002 = "E0002",
  E0003 = "E0003",
  E0004 = "E0004",
  E0005 = "E0005",
  E0006 = "E0006",
  E0007 = "E0007",
  E0101 = "E0101",
  E0102 = "E0102",
}
